export default __webpack_public_path__ + "static/media/close_door_1.1b7377d2.mp3";